export const priorityValues = [
	{ value: 0, class: "np-inactive", bg: "#ebebeb", color: "#262626", label: 'UI.task.priority_0' },
	{ value: 1, class: "np-danger", bg: "#FCEBE6", color: "#9B2406", label: 'UI.task.priority_1' },
	{ value: 2, class: "np-amber", bg: "#fafadb", color: "#816403", label: 'UI.task.priority_2' },
	{ value: 3, class: "np-success", bg: "#dbfae3", color: "#03590b", label: 'UI.task.priority_3' },
	{ value: 4, class: "np-freeze", bg: "#d4edfc", color: "#0e4f9a", label: 'UI.task.priority_4' }
]

export function formatDate(date) {
	const options = { year: 'numeric', month: 'long', day: 'numeric' }
	const d = new Date(date)
	return d.toLocaleDateString(undefined, options) + " " + d.toLocaleTimeString(undefined, options)
}

export function localeTime(timestamp) {
	if (timestamp) {
		const d = new Date(timestamp * 1000)
		return d.toLocaleTimeString('ru-RU', {hour: '2-digit', minute:'2-digit'})
	} else {
		return ""
	}
}
	
export function localeDate(timestamp) {
	if (timestamp) {
		const d = new Date(timestamp * 1000)
		return d.toLocaleDateString('ru-RU')
	} else {
		return ""
	}
}

export function localeDateTime(timestamp) {
	if (timestamp) {
		const d = new Date(timestamp * 1000)
		return d.toLocaleDateString('ru-RU') + " " + d.toLocaleTimeString('ru-RU', {hour: '2-digit', minute:'2-digit'})
	} else {
		return ""
	}
}
	
export function serialize(obj) {
	var str = []
	for (var p in obj)
	if (obj.hasOwnProperty(p)) {
		str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]))
	}
	return str.join("&")
}

export function lightenDarkenColor(col, amt) {
	var usePound = false;

	if (col[0] == "#") {
		col = col.slice(1);
		usePound = true;
	}

	var num = parseInt(col,16);
	var r = (num >> 16) + amt;

	if (r > 255) r = 255;
	else if  (r < 0) r = 0; var b = ((num >> 8) & 0x00FF) + amt;

	if (b > 255) b = 255;
	else if  (b < 0) b = 0; var g = (num & 0x0000FF) + amt; if (g > 255) g = 255;
	else if (g < 0) g = 0

	return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16)
	}
	export function nameColor( str ) {
	if (!str) return '#000'
	
	var hash = 0
	for (var i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 4) - hash)
	}
	var color = '#'
	for (var i = 0; i < 3; i++) {
		var value = (hash >> (i * 8)) & 0xFF
		color += ('00' + value.toString(16)).substr(-2)
	}
	return color
}

export function eventDate(timestamp) {

	var date = new Date(timestamp * 1000)
	var aaaa = date.getFullYear()
	var gg = date.getDate()
	var mm = (date.getMonth() + 1)

	if (gg < 10)
		gg = "0" + gg

	if (mm < 10)
		mm = "0" + mm

	var cur_day = aaaa + "-" + mm + "-" + gg

	var hours = date.getHours()
	var minutes = date.getMinutes()

	if (hours < 10)
		hours = "0" + hours

	if (minutes < 10)
		minutes = "0" + minutes

	return cur_day + " " + hours + ":" + minutes
}

export function formatBytes(bytes, decimals = 2) {
	if (!+bytes) return '0 Bytes'

	const k = 1024
	const dm = decimals < 0 ? 0 : decimals
	const sizes = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb']

	const i = Math.floor(Math.log(bytes) / Math.log(k))

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function cleanHtmlText(html, options = {}) {
	if (!html) return ''

	const div = document.createElement('div')
	div.innerHTML = html

	div.querySelectorAll('script, style').forEach(el => el.remove())

	div.querySelectorAll('br, p, div').forEach(el => {
		const textContent = el.textContent || ''
		const spaceOrNewline = options.preserveNewLines && (el.tagName === 'P' || el.tagName === 'DIV') ? '\n' : ' '
		el.replaceWith(document.createTextNode(textContent + spaceOrNewline))
	})

	if (!options.keepLinks) {
		div.querySelectorAll('a').forEach(a => {
			a.replaceWith(document.createTextNode(` ${a.textContent} `))
		})
	}

	let text = div.textContent || div.innerText || ''

	text = text.trim()

	if (options.preserveNewLines) {
		text = text.replace(/[ \t]+\n/g, '\n').replace(/\n[ \t]+/g, '\n')
		text = text.replace(/\n{3,}/g, '\n\n')
	} else {
		text = text.replace(/\s+/g, ' ').trim()
	}

	if (options.maxLength && text.length > options.maxLength) {
		text = text.substring(0, options.maxLength)
		const lastSpace = text.lastIndexOf(' ')
		if (lastSpace > 0) {
			text = text.substring(0, lastSpace)
		}
		text += '...'
	}

	return text
}

export function convertSeconds(seconds, format = 'string') {
	const days = Math.floor(seconds / 86400)
	seconds %= 86400
	
	const hours = Math.floor(seconds / 3600)
	seconds %= 3600
	
	const minutes = Math.floor(seconds / 60)
	seconds %= 60
	
	// Функция для добавления лидирующего нуля
	const pad = (num) => num.toString().padStart(2, '0')
	
	if (format === 'string') {
		const parts = []
		if (days > 0) parts.push(`${days}:`)
		parts.push(`${pad(hours)}:${pad(minutes)}:${pad(seconds)}s`)
		return parts.join('')
	} else if (format === 'object') {
		return { 
		"days": pad(days), 
		"hours": pad(hours), 
		"minutes": pad(minutes), 
		"seconds": pad(seconds) 
		}
	} else {
		throw new Error('Invalid format. Use "object" or "string".')
	}
}